<template>
    <div>
        <div class="header">
            <div class="search">
                <input
                    type="text"
                    placeholder="搜索网吧名/网吧ID"
                    v-model="keyword"
                    @keyup.enter="getClientTableList(page)"
                    @blur="getClientTableList(page)"
                />
                <a href="#" @click.prevent=""
                    ><img src="@/assets/img/icon/u502.png" alt=""
                /></a>
            </div>
            <span>下载状态：</span>
            <select v-model="downloadId" @change="getClientTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in downloadList"
                    :key="index"
                    :value="item.value"
                    v-text="item.label"
                ></option>
            </select>
            <span>分组名：</span>
            <select v-model="groupId" @change="getClientTableList(page)">
                <option value="">全部</option>
                <option
                    v-for="(item, index) in groupList"
                    :key="index"
                    :value="item.groupId"
                    v-text="item.groupName"
                ></option>
            </select>
        </div>
        <div class="table-content">
            <client-table-list
                ref="clientTableList"
                @pagechange="getClientTableList"
                :total="parseInt(total)"
                :page="parseInt(page)"
                :loading="loading"
                :table-list="clientList"
            ></client-table-list>
        </div>
    </div>
</template>
<script>
import ClientTableList from "./clientTableList";
import { mapState } from "vuex";
import { getClientTableList } from "@/requests/threeTierMission";
export default {
    name: "client",
    components: {
        ClientTableList,
    },
    data() {
        return {
            keyword: "",
            downloadId: "",
            downloadList: [
                {
                    value: 1,
                    label: "下载中",
                },
                {
                    value: 2,
                    label: "下载完成",
                },
                {
                    value: 3,
                    label: "下载失败",
                },
                {
                    value: 0,
                    label: "未下载",
                },
            ],
            groupId: "",
            total: 0,
            page: 1,
            clientList: [],
            loading: false,
            task: 0,
        };
    },
    computed: {
        ...mapState({
            groupList: (state) => state.user.barGroupList,
        }),
        allCheck() {
            return this.$refs.clientTableList.allCheck;
        },
        barIdList() {
            return this.$refs.clientTableList.selectedBarIds();
        },
    },
    methods: {
        // 分页获取客户机列表
        async getClientTableList(pageNum) {
            this.clientList = [];
            this.loading = true;
            let res = await getClientTableList({
                current: pageNum,
                size: 20,
                search: this.keyword,
                downloadStatus: this.downloadId,
                taskId: this.task,
                groupId: this.groupId,
            });
            this.clientList = res.data.records;
            this.total = parseInt(res.data.total);
            this.page = parseInt(res.data.current);
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    background: #fff;
    padding: 5px;
    border: 1px solid rgba(230, 230, 230, 1);
    .search {
        display: inline-block;
        input {
            width: 200px;
            height: 30px;
            border: 1px solid rgba(230, 230, 230, 1);
            font-size: 12px;
            color: #a1a1a1;
            padding-left: 10px;
        }
        a {
            display: inline-block;
            width: 61px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background: rgba(242, 242, 242, 1);
            border: 1px solid rgba(230, 230, 230, 1);
            border-left: none;
        }
    }
    span {
        margin-left: 10px;
    }
    select {
        outline: none;
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid rgba(230, 230, 230, 1);
    }
}
</style>
